var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03957 2.56006C4.56533 2.56006 2.55957 4.56582 2.55957 7.04006V24.9601C2.55957 27.4343 4.56533 29.4401 7.03957 29.4401H24.9596C27.4338 29.4401 29.4396 27.4343 29.4396 24.9601V7.04006C29.4396 4.56582 27.4338 2.56006 24.9596 2.56006H7.03957ZM8.37457 8.32006H13.4546L17.0621 13.4463L21.4396 8.32006H23.0396L17.7846 14.4726L24.2646 23.6801H19.1858L14.9996 17.7326L9.91957 23.6801H8.31957L14.2771 16.7063L8.37457 8.32006ZM10.8246 9.60006L19.8533 22.4001H21.8146L12.7858 9.60006H10.8246Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2213e7ec46cd9a5f7d3b07f18cafd634.svg";
export { ForwardRef as ReactComponent };